import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype/internal/keywords/keywords.ts'

import cartDb from '@/lib/cart/cartDb'
import {getCartQueryKey} from '@/lib/cart/hooks/useCart'
import {countryAtom} from '@/lib/locale/country'
import {localeAtom} from '@/lib/locale/locale'
import {CheckoutResult} from '@/models/cartModel'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  orderId: '',
  guest: false,
}

const checkoutResultSearchSchema = type({
  orderId: searchParamString.optional(),
  guest: fallbackToDefault(type.boolean, DEFAULT_VALUES.guest),
})

export const Route = createFileRoute('/_shop/checkout/$result/')({
  validateSearch: checkoutResultSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  beforeLoad: ({search, params, context: {store, queryClient}}) => {
    if (params.result === CheckoutResult.Success.toString() && search.guest) {
      const country = store.get(countryAtom)
      cartDb.clearCart(country)

      const locale = store.get(localeAtom)
      void queryClient.invalidateQueries({
        queryKey: getCartQueryKey({locale}),
        exact: true,
      })
    }
  },
})
